import SectionHeading from '../shared/SectionHeading'
import styles from './styles.module.scss'

const TARGET_PREFIXES = [
  '駅・観光地・イベント会場の近くにある',
  'スーツケース数個分の空きスペースがある',
  '旅行者やイベント参加者の来店を増やしたい',
  '地域の観光課題の解決に協力したい',
  '空き時間・遊休スペースを活用したい',
  '新しい収益の柱をつくりたい',
]

const TargetStoreSection = (): JSX.Element => (
  <section className={`${styles.block}`}>
    <div className={`${styles.content} ${styles.center}`}>
      <SectionHeading
        eyebrow="こんなお店を探しています"
        title="空きスペースが、誰かの自由になる"
        description="スーツケース数個分の空きスペースがあれば、どんな業種でも始められます。"
      />
      <div className={styles.targetGrid}>
        {TARGET_PREFIXES.map((text) => (
          <div className={`${styles.targetCard} ${styles.reveal}`} data-reveal="" key={text}>
            <div className={styles.targetCheck}>✓</div>
            <p>
              {text}
              <span className={styles.noWrap}>店舗</span>
            </p>
          </div>
        ))}
      </div>
      <div className={`${styles.targetTags} ${styles.reveal}`} data-reveal="">
        <span>カフェ・飲食店</span>
        <span>美容室</span>
        <span>小売店</span>
        <span>レンタルスペース</span>
        <span>観光案内所</span>
        <span>ホテル</span>
      </div>
    </div>
  </section>
)

export default TargetStoreSection
